import React from 'react';
import RichTextEditor from '../ui/RichTextEditor';
import InfoTooltip from '../ui/InfoTooltip';

export default function ProductEditorFields({
  name,
  onNameChange,
  description,
  onDescriptionChange,
  price,
  onPriceChange,
  videoLink,
  onVideoLinkChange,
  imagePreviewUrl = '',
  onImageFileChange,
  imageFileName = '',
}) {
  return (
    <div className="space-y-4">
      <div>
        <label className="flex items-center gap-1 text-sm font-medium text-foreground mb-1.5">
          Photo
          <InfoTooltip text="Image principale — visible sur la fiche produit." />
        </label>
        {imagePreviewUrl ? (
          <div className="mb-2 overflow-hidden rounded-lg border border-border aspect-[4/3] max-h-40 bg-muted/30">
            <img src={imagePreviewUrl} alt="" className="h-full w-full object-cover" />
          </div>
        ) : null}
        <input
          type="file"
          accept="image/jpeg,image/png,image/gif,image/webp"
          onChange={(e) => onImageFileChange?.(e.target.files?.[0] || null)}
          className="block w-full text-xs text-muted-foreground file:mr-3 file:rounded-md file:border-0 file:bg-muted file:px-3 file:py-2 file:text-xs file:font-medium"
        />
        {imageFileName ? (
          <p className="mt-1 text-xs text-muted-foreground">{imageFileName}</p>
        ) : null}
      </div>
      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">
          Nom <span className="text-error">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          placeholder="Nom du produit"
        />
      </div>
      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">Description</label>
        <RichTextEditor value={description || ''} onChange={onDescriptionChange} minEditorHeight={120} />
      </div>
      <div>
        <label className="flex items-center gap-1 text-sm font-medium text-foreground mb-1.5">
          Prix TTC (€)
          <InfoTooltip text="Laisser vide ou 0 si le prix n'est pas affiché." />
        </label>
        <input
          type="number"
          min="0"
          step="0.01"
          value={price}
          onChange={(e) => onPriceChange(e.target.value)}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          placeholder="Ex. 99.90"
        />
      </div>
      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">
          Lien vidéo (optionnel)
        </label>
        <input
          type="url"
          value={videoLink}
          onChange={(e) => onVideoLinkChange(e.target.value)}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          placeholder="https://youtube.com/..."
        />
      </div>
    </div>
  );
}
